import { Alert, Grid2 } from "@mui/material";
import { useEffect, useState } from "react";
import { ClientPaymentTermsEnum } from "../../../_common/enum/clientPaymentTerms.enum";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { caseService } from "../../../_services/case.service";

function splitByCapital(text?: string) {
    if (!text) return "";
    return text
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
        .trim();
}

export function TicketClientPaymentTerms({ caseId }: { caseId?: string | number }) {
    const [paymentTerms, setPaymentTerms] = useState<string | null>(null);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!caseId) {
            setPaymentTerms(null);
            setLoaded(false);
            return;
        }

        setLoaded(false);
        caseService
            .get(String(caseId))
            .then(
                (json) => {
                    const termsId = json?.clientPaymentTermsId;
                    const label = termsId != null
                        ? splitByCapital(ClientPaymentTermsEnum[termsId] as string)
                        : null;
                    setPaymentTerms(label);
                },
                handleErrorResponse
            )
            .finally(() => setLoaded(true));
    }, [caseId]);

    if (!caseId || !loaded) return null;

    if (paymentTerms == null) {
        return (
            <Grid2 size={{ xs: 12 }}>
                <Alert severity="warning">
                    Payment terms not set for this Client
                </Alert>
            </Grid2>
        );
    }

    return (
        <Grid2 size={{ xs: 12 }}>
            <StandardTextValidator
                key="clientPaymentTerms"
                name="clientPaymentTerms"
                label="Payment Terms"
                fullWidth
                disabled
                value={paymentTerms}
            />
        </Grid2>
    );
}
